export const SET_BEHAVE_AS = "SET_BEHAVE_AS";
export const RESET_BEHAVE_AS = "RESET_BEHAVE_AS";
